import { PageTags, Params } from './types';
import ProjectPageTags from './ProjectPageTags';
import CustomerPageTags from './CustomerPageTags';
import HomePageTags from './HomePageTags';
import UserPageTags from './UserPageTags';
import ProfilePageTags from './ProfilePageTags';
import OrganizationPageTags from './OrganizationPageTags';
import VideoMenuPageTags from './VideoMenuPageTags';
import VideoPageTags from './VideoPageTags';
import PlanCheckoutTags from './PlanCheckoutTags';

class LightHouseTags {
  static get pageRoutes(): { [key: string]: typeof PageTags } {
    return {
      '/dashboard/home': HomePageTags,
      '/dashboard/projects': ProjectPageTags,
      '/dashboard/admin/customers': CustomerPageTags,
      '/dashboard/admin/users': UserPageTags,
      '/dashboard/user/organizations': OrganizationPageTags,
      '/dashboard/users': UserPageTags,
      '/dashboard/profile': ProfilePageTags,
      '/dashboard/admin/profile': ProfilePageTags,
      '/dashboard/admin/organizations': OrganizationPageTags,
      '/dashboard/admin/video-menus': VideoMenuPageTags,
      '/dashboard/admin/videos': VideoPageTags,
      '/dashboard/plans/checkout': PlanCheckoutTags,
    };
  }

  static getByPath({ pathname, exact = true }: Params): string[] {
    let commonPath = '';

    // eslint-disable-next-line no-restricted-syntax
    for (const [key] of Object.entries(this.pageRoutes)) {
      if (pathname.startsWith(key)) {
        commonPath = key;
        break;
      }
    }

    const pageRoute = this.pageRoutes[commonPath];

    if (pageRoute) {
      const tags = pageRoute.get({ pathname, exact });
      if (tags) {
        return tags;
      }
    }

    // default
    return [
      'tag:getting-started',
      'tag:dashboard',
      'tag:release-notes',
    ];
  }
}

export default LightHouseTags;
